(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2760,1620,2472,9600],{

/***/ 93228:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 82941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(93228),
    isIterateeCall = __webpack_require__(82406),
    toFinite = __webpack_require__(5707);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 1842:
/***/ (function(module) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ 2689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(82941);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 5707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(7642);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 8936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ marketing; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 4 modules
var DemoForm = __webpack_require__(92472);
// EXTERNAL MODULE: ./src/views/Marketing/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(77481);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/Marketing/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(37883);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/Marketing/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(39764);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Marketing/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var copy = {
  overline: "For Marketing Teams",
  heading: "Know your customer, hit your goals",
  description: "No cookies? No problem. Segment helps you collect valuable first-party data, reducing your customer acquisition cost and increasing return on ad spend by enabling better targeting and multichannel engagement."
};

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeroComponent, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeroCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          tag: "h5",
          variant: "h5",
          children: copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
            "data-hook": "demoFormContainer",
            isProgressive: true,
            customFormIdentifier: "site-marketing-demo",
            successMessageAppearance: "twilioLight"
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroContent, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImage, {
            role: "presentation",
            width: "640",
            height: "512",
            src: (Hero_2x_default()),
            alt: "",
            loading: "lazy"
          })]
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1l007nr4"
} : 0)("overflow:hidden;position:relative;z-index:0;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var HeroComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e1l007nr3"
} : 0)( true ? {
  name: "1v8apbr",
  styles: "position:relative;z-index:-1"
} : 0);

var HeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Copy */.CK,  true ? {
  target: "e1l007nr2"
} : 0)( true ? {
  name: "18xjriy",
  styles: "max-width:470px"
} : 0);

var HeroContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Contents */.AU,  true ? {
  target: "e1l007nr1"
} : 0)("position:relative;&::after{content:'';display:block;height:0;overflow:hidden;padding-top:80%;position:relative;pointer-events:none;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:70%;}}" + ( true ? "" : 0));

var HeroImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1l007nr0"
} : 0)( true ? {
  name: "m2x76b",
  styles: "position:absolute;top:50%;left:50%;z-index:-1;transform:translate(-50%, -50%)"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/index.ts + 1 modules
var LogoCarousel = __webpack_require__(6087);
;// CONCATENATED MODULE: ./src/views/Marketing/components/LogoCarousel/LogoCarousel.tsx





var LogoCarouselComponent = function LogoCarouselComponent() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel["default"], {})
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ezn321r0"
} : 0)(Section/* Wrapper */.im, "{padding-bottom:20px;}" + ( true ? "" : 0));

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarouselComponent);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 229 modules
var CompanyMono = __webpack_require__(71385);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Testimonial/index.ts + 11 modules
var Testimonial = __webpack_require__(60814);
;// CONCATENATED MODULE: ./src/views/Marketing/components/Testimonial/Testimonial.tsx







var Testimonial_copy = {
  description: "\u201CHaving Segment has not only helped us to do the personalization work we\u2019ve always wanted to do, but we can now improve on the effectiveness of our ad campaigns and drive that feedback loop.\u201D",
  author: "Christian Rocha Castillo",
  role: "Deputy Director Ecommerce/Digital Media"
};

var TestimonialComponent = function TestimonialComponent() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial_StyledSectionBase, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* default */.ZP, {
        variant: "base",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* Base */.XY, {
          height: "auto",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* BaseContentSlot */.b6, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseLogo */.jo, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DominosMonoLogo */.ooH, {
                color: "".concat(theme.palette.neutrals.white["100"])
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseText */.k$, {
              children: Testimonial_copy.description
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseAuthorSlot */.hC, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* AuthorInfo */.d7, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorName */.U2, {
                children: Testimonial_copy.author
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorPosition */.a6, {
                children: Testimonial_copy.role
              })]
            })
          })]
        })
      })
    })
  });
};

var Testimonial_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eueuwrh0"
} : 0)(Section/* Wrapper */.im, "{row-gap:0;", Section/* Contents */.AU, "{max-width:900px;}}" + ( true ? "" : 0));

/* harmony default export */ var Testimonial_Testimonial = (TestimonialComponent);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 92 modules
var Brandbook = __webpack_require__(79550);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
;// CONCATENATED MODULE: ./src/views/Marketing/components/CompleteView/CompleteView.tsx


function CompleteView_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var features = [{
  heading: "Targeted messaging",
  description: "Deliver a message that's timed and tailored to each audience, suitable for their preferred platform, and designed to influence behavior.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* EmailIcon */.LQ, {})
}, {
  heading: "Multichannel personalization",
  description: "Real-time customer profiles enable the creation of dynamic audiences, allowing for seamless journeys across both native and external channels, including both paid and owned media.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* ToolIcon */.Ec, {})
}, {
  heading: "CustomerAI Predictions",
  description: "Get trusted AI at your fingertips to effortlessly anticipate upcoming customer actions and create tailored campaigns without relying on data science teams.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* NamingConventionsIcon */.eo, {})
}];
var CompleteView_copy = {
  heading: "Get a complete view of your customer",
  description: "Understand your customer journey and unify every customer touchpoint across all platforms and channels."
};
var CompleteView = function CompleteView() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompleteView_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompleteView_StyledSectionBase, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: CompleteView_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: CompleteView_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          columns: 1,
          overrides: {
            md: 3
          },
          children: features.map(function (feature, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledFeatureBoxBase, {
              headerPosition: "top",
              alignment: "left",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
                  variant: "circle",
                  elevation: 1,
                  children: feature.icon
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: feature.heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  children: feature.description
                })]
              })]
            }, index);
          })
        })
      })]
    })
  });
};

var CompleteView_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e179wgza3"
} : 0)("margin-bottom:40px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{margin-bottom:100px;}" + ( true ? "" : 0));

var CompleteView_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e179wgza2"
} : 0)("max-width:1280px;", Section/* Wrapper */.im, "{padding-top:40px;}" + ( true ? "" : 0));

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e179wgza1"
} : 0)( true ? {
  name: "837xmr",
  styles: "max-width:684px"
} : 0);

var StyledFeatureBoxBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* default */.ZP,  true ? {
  target: "e179wgza0"
} : 0)("max-width:336px;justify-self:center;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{max-width:unset;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding:0 15px;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("xxl");
}, "{padding:24px 15px;}" + ( true ? "" : 0));

/* harmony default export */ var CompleteView_CompleteView = (CompleteView);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/Marketing/components/DeliverUnifiedCustomerExperiences/assets/DeliverUnifiedCustomerExperiences@2x.png
var DeliverUnifiedCustomerExperiences_2x = __webpack_require__(5083);
var DeliverUnifiedCustomerExperiences_2x_default = /*#__PURE__*/__webpack_require__.n(DeliverUnifiedCustomerExperiences_2x);
// EXTERNAL MODULE: ./src/views/Marketing/components/DeliverUnifiedCustomerExperiences/assets/DeliverUnifiedCustomerExperiences.webp
var DeliverUnifiedCustomerExperiences = __webpack_require__(85891);
var DeliverUnifiedCustomerExperiences_default = /*#__PURE__*/__webpack_require__.n(DeliverUnifiedCustomerExperiences);
// EXTERNAL MODULE: ./src/views/Marketing/components/DeliverUnifiedCustomerExperiences/assets/DeliverUnifiedCustomerExperiences@2x.webp
var assets_DeliverUnifiedCustomerExperiences_2x = __webpack_require__(80405);
var assets_DeliverUnifiedCustomerExperiences_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DeliverUnifiedCustomerExperiences_2x);
;// CONCATENATED MODULE: ./src/views/Marketing/components/DeliverUnifiedCustomerExperiences/DeliverUnifiedCustomerExperiencesImage.tsx








var DeliverUnifiedCustomerExperiencesImage = function DeliverUnifiedCustomerExperiencesImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((DeliverUnifiedCustomerExperiences_default()), ", ").concat((assets_DeliverUnifiedCustomerExperiences_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
      src: (DeliverUnifiedCustomerExperiences_2x_default()),
      alt: "Illustration: Deliver Unified Customer Experiences",
      width: "640",
      height: "411",
      loading: "lazy"
    })]
  });
};

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1bxn2su0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{margin-top:80px;}" + ( true ? "" : 0));

/* harmony default export */ var DeliverUnifiedCustomerExperiences_DeliverUnifiedCustomerExperiencesImage = (DeliverUnifiedCustomerExperiencesImage);
;// CONCATENATED MODULE: ./src/views/Marketing/components/DeliverUnifiedCustomerExperiences/DeliverUnifiedCustomerExperiences.tsx


function DeliverUnifiedCustomerExperiences_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var DeliverUnifiedCustomerExperiences_copy = {
  heading: "Deliver unified, personalized customer experiences",
  description: "Build and activate data-driven, personalized campaigns across every customer channel from a centralized platform without relying on technical teams."
};
var DeliverUnifiedCustomerExperiences_link = {
  text: "Explore Twilio Engage",
  url: "/product/twilio-engage/"
};
var DeliverUnifiedCustomerExperiences_features = [{
  heading: "Engage anywhere in real time",
  description: "Activate insights in real time, eliminating the need for manual data reconciliation and collaboration with other teams and systems.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* AnnouncementIcon */.HR, {})
}, {
  heading: "Orchestrate journeys wherever your data is",
  description: "Enhance customer engagement with personalized experiences across their preferred channels\u2014email, SMS, WhatsApp, Push Notifications, and more\u2014leveraging our 450+ ready-to-use integrations and customizable options.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* PlugIcon */.BW, {})
}, {
  heading: "Build a complete view of your customer",
  description: "Create profiles and audiences with real-time customer interactions collected across digital touchpoints, without SQL expertise.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* UserIcon */.tB, {})
}];

var DeliverUnifiedCustomerExperiences_DeliverUnifiedCustomerExperiences = function DeliverUnifiedCustomerExperiences() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionWrapper, {
    variant: "2Col",
    copyVariant: "narrow",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: DeliverUnifiedCustomerExperiences_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: DeliverUnifiedCustomerExperiences_copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          href: (0,getAbsoluteUrl/* default */.Z)(DeliverUnifiedCustomerExperiences_link.url, pageConfig),
          children: DeliverUnifiedCustomerExperiences_link.text
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          gap: "small",
          children: DeliverUnifiedCustomerExperiences_features.map(function (feature, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* default */.ZP, {
              alignment: "left",
              headerPosition: "left",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
                  elevation: 1,
                  variant: "circle",
                  children: feature.icon
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: feature.heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  children: feature.description
                })]
              })]
            }, index);
          })
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliverUnifiedCustomerExperiences_DeliverUnifiedCustomerExperiencesImage, {})
    })]
  });
};

var SectionWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1rn1uyi1"
} : 0)("overflow-x:visible;", Section/* Wrapper */.im, "{", Section/* Copy */.CK, "{max-width:440px;}}" + ( true ? "" : 0));

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1rn1uyi0"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

/* harmony default export */ var components_DeliverUnifiedCustomerExperiences_DeliverUnifiedCustomerExperiences = (DeliverUnifiedCustomerExperiences_DeliverUnifiedCustomerExperiences);
// EXTERNAL MODULE: ./src/views/Marketing/assets/OgMarketing.jpeg
var OgMarketing = __webpack_require__(62806);
var OgMarketing_default = /*#__PURE__*/__webpack_require__.n(OgMarketing);
;// CONCATENATED MODULE: ./src/views/Marketing/Marketing.tsx















var TestimonialSlider = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7209), __webpack_require__.e(8302), __webpack_require__.e(2597)]).then(__webpack_require__.bind(__webpack_require__, 88302));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(88302)];
    }
  }
});
var GettingStarted = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(442), __webpack_require__.e(5124)]).then(__webpack_require__.bind(__webpack_require__, 42576));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(42576)];
    }
  }
});
var RobustMarketingAppstore = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 5185).then(__webpack_require__.bind(__webpack_require__, 65185));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(65185)];
    }
  }
});
var RealTimeAudiences = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1965).then(__webpack_require__.bind(__webpack_require__, 21965));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(21965)];
    }
  }
});
var Persona = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2974).then(__webpack_require__.bind(__webpack_require__, 72974));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(72974)];
    }
  }
});
var PushTraits = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4218), __webpack_require__.e(5631)]).then(__webpack_require__.bind(__webpack_require__, 85631));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(85631)];
    }
  }
});

var MarketingView = function MarketingView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Marketing | Twilio Segment for Marketing",
      pageDescription: "Twilio Segment is a customer data platform (CDP) that helps you collect, clean, and activate your customer data.",
      pageOG: (OgMarketing_default()),
      themeColor: theme.palette.brand.darkAcai[800],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel_LogoCarousel, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial_Testimonial, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompleteView_CompleteView, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Persona, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PushTraits, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealTimeAudiences, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DeliverUnifiedCustomerExperiences_DeliverUnifiedCustomerExperiences, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RobustMarketingAppstore, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialSlider, {
          title: false
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted, {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "eaab4jq0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Marketing_Marketing = (MarketingView);
;// CONCATENATED MODULE: ./src/pages/marketing.tsx



var Marketing = function Marketing() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Marketing_Marketing, {});
};

/* harmony default export */ var marketing = (Marketing);

/***/ }),

/***/ 96856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useLocation_useLocation; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/client.ts + 2 modules
var client = __webpack_require__(39896);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/location.ts



var fetchLocation = function fetchLocation(client, signal) {
  return client.get("/location/", {
    signal: signal,
    headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
  });
};

var fetchLocationCode = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, signal) {
    var code;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/location/countryCode/", {
              signal: signal,
              headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
            });

          case 2:
            code = _context.sent;
            return _context.abrupt("return", code.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchLocationCode(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();


;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/useLocation.ts





/**
 * A hook that provides the country code of the user's location.
 * @returns The country code of the user's location.
 */

var useLocation = function useLocation() {
  var _useState = (0,react.useState)(""),
      code = _useState[0],
      setCode = _useState[1];

  var fetchData = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(signal) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchLocationCode((0,client/* createClient */.e)(), signal);

            case 3:
              response = _context.sent;
              setCode(response.toLowerCase());
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setCode("us");

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  (0,react.useEffect)(function () {
    var controller = new AbortController();
    fetchData(controller.signal);
    return function () {
      controller.abort();
    };
  }, [fetchData]);
  return code;
};

/* harmony default export */ var useLocation_useLocation = (useLocation);
;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/index.ts


/***/ }),

/***/ 805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DemoProvider; },
/* harmony export */   "d": function() { return /* binding */ DemoContext; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var DemoContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  completedFormData: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCompletedFormData: function setCompletedFormData() {}
});
var DemoProvider = function DemoProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    completedFormData: undefined,
    setCompletedFormData: function setCompletedFormData(value) {
      return setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          completedFormData: value
        });
      });
    }
  }),
      state = _useState[0],
      setState = _useState[1];

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(DemoContext.Provider, {
    value: state,
    children: children
  });
};

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 79600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ components_IconWrapper_IconWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var IconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bo4d8j1"
} : 0)("width:44px;height:44px;border-radius:50%;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";", function (_ref4) {
  var elevation = _ref4.elevation,
      theme = _ref4.theme;
  return elevation &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("box-shadow:", theme.shadows[elevation], ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "1iixa1j",
  styles: "width:40px;height:40px;svg{width:40px;height:40px;}padding:2px"
} : 0;

var Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1bo4d8j0"
} : 0)("display:block;width:24px;height:24px;padding:10px;", function (_ref5) {
  var variant = _ref5.variant;
  return variant === "transparent" && _ref;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.tsx


var _excluded = ["tokens", "variant", "elevation", "className", "tag", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseIconWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      variant = _ref.variant,
      elevation = _ref.elevation,
      className = _ref.className,
      tag = _ref.tag,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: className,
    elevation: elevation,
    as: tag
  }, tokens), rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      variant: variant,
      children: children
    })
  }));
});

var getBackgroundPropTokens = function getBackgroundPropTokens(background, theme) {
  switch (background) {
    case "white":
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.brand.boysenberry[500]
      };

    case "light":
      return {
        backgroundColor: theme.palette.brand.boysenberry[100],
        color: theme.palette.brand.darkAcai[700]
      };

    case "dark":
      return {
        backgroundColor: theme.palette.brand.darkAcai[600],
        color: theme.palette.brand.boysenberry[200]
      };

    default:
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.twilio.gray[100]
      };
  }
};

var IconWrapper_IconWrapper = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIconWrapper, function (_ref2) {
  var elevation = _ref2.elevation;
  return {
    elevation: elevation
  };
}, {
  light: function light(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.brand.darkAcai[700],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.darkAcai[700],
      backgroundColor: theme.palette.brand.boysenberry[100]
    };
  },
  dark: function dark(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.neutrals.white[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.boysenberry[200],
      backgroundColor: theme.palette.brand.darkAcai[600]
    };
  },
  twilioLight: function twilioLight(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.twilio.gray[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.twilio.gray[100],
      backgroundColor: theme.palette.neutrals.white[100]
    };
  }
});
/* harmony default export */ var components_IconWrapper_IconWrapper = (IconWrapper_IconWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/index.ts


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 77840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ FormSubmitMessage; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/data.tsx
var data = {
  success: {
    demo: {
      description: "Thank you for submitting your request for a demo! Answer 4 more questions to help us pinpoint exactly what your team needs to get started with Segment."
    }
  },
  error: {
    demo: {
      description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again."
    }
  }
};
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq3"
} : 0)("padding:32px;border:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";border-radius:8px;text-align:left;" + ( true ? "" : 0));
var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq2"
} : 0)( true ? {
  name: "9qwgfz",
  styles: "display:grid;grid-auto-flow:column;grid-template-columns:max-content 1fr;align-items:center;gap:8px"
} : 0);
var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq1"
} : 0)( true ? {
  name: "172op4w",
  styles: "margin-top:0;margin-bottom:0"
} : 0);
var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq0"
} : 0)( true ? {
  name: "7ut0hf",
  styles: "margin:0;margin-bottom:16px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx


var _excluded = ["form", "status", "heading", "description", "tokens", "appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseFormSubmitMessage = function BaseFormSubmitMessage(_ref) {
  var form = _ref.form,
      status = _ref.status,
      heading = _ref.heading,
      description = _ref.description,
      tokens = _ref.tokens,
      externalAppearance = _ref.appearance,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var localData = form && data[status][form];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens.wrapper), rest), {}, {
      children: [heading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
          variant: "h4",
          tag: "p",
          tokens: tokens.header,
          children: heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
        variant: "pMedium",
        tokens: tokens.description,
        children: description || (localData === null || localData === void 0 ? void 0 : localData.description)
      })]
    }))
  });
};

var FormSubmitMessage = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFormSubmitMessage, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[300]
      }
    };
  },
  light: function light(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[500]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.twilio.gray[100]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.neutrals.white[100]
      }
    };
  }
});
/* harmony default export */ var FormSubmitMessage_FormSubmitMessage = ((/* unused pure expression or super */ null && (FormSubmitMessage)));

/***/ }),

/***/ 92472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DemoForm; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/lodash/isNil.js
var isNil = __webpack_require__(1842);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 23 modules
var FormFields = __webpack_require__(20444);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx + 2 modules
var FormSubmitMessage = __webpack_require__(77840);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/api/utils/useLocation/index.ts + 2 modules
var useLocation = __webpack_require__(96856);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/sharedEmail.ts
var sharedEmail = __webpack_require__(13206);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/utils/regexes/lastName.ts
var lastName = __webpack_require__(51895);
// EXTERNAL MODULE: ../../libs/utils/regexes/website.ts
var website = __webpack_require__(10137);
;// CONCATENATED MODULE: ../../libs/utils/regexes/personalEmail.ts
var personalEmailRegex = /@(gmail|yahoo|hotmail|me|icloud|personal)\.com$/g;
/* harmony default export */ var personalEmail = (personalEmailRegex);
;// CONCATENATED MODULE: ../../libs/utils/regexes/forbiddenEmail.ts
var customDomainList = ["@gmail.com", "@yahoo.com", "@hotmail.com", "@aol.com", "@hotmail.co.uk", "@hotmail.fr", "@msn.com", "@yahoo.fr", "@wanadoo.fr", "@orange.fr", "@comcast.net", "@yahoo.co.uk", "@yahoo.com.br", "@yahoo.co.in", "@live.com", "@rediffmail.com", "@free.fr", "@gmx.de", "@web.de", "@yandex.ru", "@ymail.com", "@libero.it", "@outlook.com", "@uol.com.br", "@bol.com.br", "@mail.ru", "@cox.net", "@hotmail.it", "@sbcglobal.net", "@sfr.fr", "@live.fr", "@verizon.net", "@live.co.uk", "@googlemail.com", "@yahoo.es", "@ig.com.br", "@live.nl", "@bigpond.com", "@terra.com.br", "@yahoo.it", "@neuf.fr", "@yahoo.de", "@alice.it", "@rocketmail.com", "@att.net", "@laposte.net", "@facebook.com", "@bellsouth.net", "@yahoo.in", "@hotmail.es", "@charter.net", "@yahoo.ca", "@yahoo.com.au", "@rambler.ru", "@hotmail.de", "@tiscali.it", "@shaw.ca", "@yahoo.co.jp", "@sky.com", "@earthlink.net", "@optonline.net", "@freenet.de", "@t-online.de", "@aliceadsl.fr", "@virgilio.it", "@home.nl", "@qq.com", "@telenet.be", "@me.com", "@yahoo.com.ar", "@tiscali.co.uk", "@yahoo.com.mx", "@voila.fr", "@gmx.net", "@mail.com", "@planet.nl", "@tin.it", "@live.it", "@ntlworld.com", "@arcor.de", "@yahoo.co.id", "@frontiernet.net", "@hetnet.nl", "@live.com.au", "@yahoo.com.sg", "@zonnet.nl", "@club-internet.fr", "@juno.com", "@optusnet.com.au", "@blueyonder.co.uk", "@bluewin.ch", "@skynet.be", "@sympatico.ca", "@windstream.net", "@mac.com", "@centurytel.net", "@chello.nl", "@live.ca", "@aim.com", "@bigpond.net.au", "@email.com", "@gmail", "@yahoo", "@hotmail", "@outlook", "@protonmail", "@gwk.com", "@free.", "@tutanota", "@gmx", "@mail2world", "@icloud", "@segment.com", "@.om", "@163.com", "@qq", "@gmai.com", "@yaoo.com", "@company.com", "@gail.com", "@abc.com", "@domain.com", "@gma.com", "@gnail.com", "@li.com", "@yah.com", "@5euros.com", "@business.com", "@emil.com", "@gaylord.info", "@gimal.com", "@gml.com", "@info.com", "@mailinator.com", "@w.com", "@yhoo.com", "@yo.com", "@0546876.com", "@10.com", "@101.gmail.com", "@11.com", "@12356gmail.com", "@123yahoo.com", "@175gmali.com", "@1servicesteamfrazier.com", "@2gmail.com", "@2ncad.com", "@365gmial.com", "@37.com", "@5024gmail.com", "@70gmail.com", "@72gmail.co.com", "@81gmail.com", "@8543g.mail.com", "@9085.gmail.com", "@9784.com", "@asdf.com", "@asdfas222334.com", "@asdsad.com", "@fuckyou.com", "@g.com", "@g.email", "@gamill.com", "@gimel.com", "@gl.com", "@gmaiil.com", "@gmaik.com", "@gmail-elif.com", "@gmail.com.pk", "@gmail.com120194", "@gmail.com4", "@gmaile.com", "@gmaill.com", "@gmaiol.com", "@gmaqil.com", "@gmaul.com", "@gmeel.come", "@gmil.comraj", "@gmsil.com", "@gmw.ere", "@gnail.con", "@haha.com", "@hahaha.com", "@il.co", "@il.com", "@test.cc", "@us.army.mil", "@ya.com", "@yaahoo.com", "@yahoo.coin", "@yho.com", "@yohoo.com", "@.aim", "@zoho", "@protonmail.com", "@mailinator", "@boutique1.com", "@bugfoo.com", "@duiter.com", "@fectode.com", "@gmial.com", "@jewelry.com", "@jims.net", "@jthoven.com", "@lolcorporate.com", "@naver.com", "@restaurant.com", "@stayclearbeauty.com", "@tem.com.my", "@thegymgroup.com", "@Marco.com"]; // Escape the dots in the domains, as they have a special meaning in regex

var escapedDomains = customDomainList.map(function (domain) {
  return domain.replace(/\./g, "\\.");
}); // Create the regex pattern using negative lookahead
// eslint-disable-next-line @typescript-eslint/naming-convention

var regexPattern = "^(?!.*(".concat(escapedDomains.join("|"), ")).*$");
var forbiddenEmailRegex = new RegExp(regexPattern, "i"); // Use the 'i' flag for case-insensitive matching

/* harmony default export */ var forbiddenEmail = (forbiddenEmailRegex);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx + 2 modules
var ProgressiveProfileForm = __webpack_require__(6612);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.views.tsx

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc2"
} : 0)( true ? "" : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc1"
} : 0)( true ? "" : 0);
var DisclaimerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.tsx



var _excluded = ["appearance", "className", "before", "after", "isProgressive", "isLeadEnrichmentFormEnabled", "overrideConsent", "customFormIdentifier", "customTrackingType", "successMessageAppearance", "onEmailCompleted", "buttonText", "customDisclaimer", "driftCampaignId", "isDemoRequest", "successMessage"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






























var MOBILE_OFFSET = -150;
var DESKTOP_OFFSET = -350;
var FORM_ID = "demo-form"; // Set up demo form props since we define some of these props here in the template

var DemoForm = function DemoForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$isProgressive = _ref.isProgressive,
      isProgressive = _ref$isProgressive === void 0 ? false : _ref$isProgressive,
      _ref$isLeadEnrichment = _ref.isLeadEnrichmentFormEnabled,
      isLeadEnrichmentFormEnabled = _ref$isLeadEnrichment === void 0 ? true : _ref$isLeadEnrichment,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      customTrackingType = _ref.customTrackingType,
      successMessageAppearance = _ref.successMessageAppearance,
      onEmailCompleted = _ref.onEmailCompleted,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "Get a demo" : _ref$buttonText,
      customDisclaimer = _ref.customDisclaimer,
      driftCampaignId = _ref.driftCampaignId,
      _ref$isDemoRequest = _ref.isDemoRequest,
      isDemoRequest = _ref$isDemoRequest === void 0 ? false : _ref$isDemoRequest,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var countryCode = (0,useLocation/* default */.Z)(); // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality

  var _useState = (0,react.useState)(false),
      emailCompleted = _useState[0],
      setEmailCompleted = _useState[1];

  var _useState2 = (0,react.useState)(undefined),
      intPhoneErrorCode = _useState2[0],
      setIntPhoneErrorCode = _useState2[1];

  var _useState3 = (0,react.useState)(),
      submittedEmail = _useState3[0],
      setSubmittedEmail = _useState3[1];
  /* eslint-disable camelcase */


  var schema = (0,react.useMemo)(function () {
    var _z$object;

    return lib/* object */.Ry((_z$object = {
      email: lib/* string */.Z_({
        required_error: FormFields/* companyEmailMessages.required */.BN.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(email/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      })
      /* This is equal to .email( { message: companyEmailMessages.invalid }) but with a custom regex */
      .regex(sharedEmail/* default */.C, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(isDemoRequest ? forbiddenEmail : /.+/, {
        message: FormFields/* companyEmailMessages.forbiddenEmail */.BN.forbiddenEmail
      }),
      name: lib/* string */.Z_({
        required_error: FormFields/* fullNameMessages.required */.aZ.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }).regex(lastName/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }),
      phone: lib/* string */.Z_({
        invalid_type_error: FormFields/* phoneNumberMessages.invalid */.NJ.invalid
      }).min(1, FormFields/* phoneNumberMessages.required */.NJ.required).refine(function () {
        return intPhoneErrorCode === undefined;
      }, {
        message: (0,FormFields/* getPhoneErrorMessage */.AP)(intPhoneErrorCode)
      })
    }, (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_VALID_FIELD */.tj, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_ERRORS_FIELD */.q5, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_CALLING_COUNTRY_CODE */.iZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_COUNTRY_CODE */.$l, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NUMBER */.SZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NATIONAL_FORMAT */.UN, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, "company", lib/* string */.Z_({
      required_error: FormFields/* companyNameMessages.required */.qx.required
    }).regex(regexes_form/* default */.Z, {
      message: FormFields/* companyNameMessages.invalid */.qx.invalid
    })), (0,defineProperty/* default */.Z)(_z$object, "companyWebsite", lib/* string */.Z_({
      required_error: FormFields/* companyWebsiteMessages.required */.e4.required
    }).regex(regexes_form/* default */.Z, {
      message: FormFields/* companyWebsiteMessages.invalid */.e4.invalid
    }).regex(website/* default */.Z, {
      message: FormFields/* companyWebsiteMessages.invalid */.e4.invalid
    })), _z$object)).partial({
      companyWebsite: true
    });
  }, [intPhoneErrorCode]);
  /* eslint-enable camelcase */

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  }); // Watch for personal email

  var watchedEmail = methods === null || methods === void 0 ? void 0 : methods.watch("email", "");
  var isPersonalEmail = !isNil_default()(watchedEmail === null || watchedEmail === void 0 ? void 0 : watchedEmail.match(personalEmail)); // If this is the progressive version of the form, set up email watching
  // Otherwise just always return true

  var showProgressiveFields = isProgressive ? Boolean(watchedEmail || emailCompleted) : true; // Mobile breakpoints

  var mobileResolutionMediaQuery = theme.breakpoints.down("md", false);
  var isSmallResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, true);
  (0,react.useEffect)(function () {
    if (watchedEmail) {
      setEmailCompleted(true);
      if (onEmailCompleted) onEmailCompleted();
    }
  }, [watchedEmail]);
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo-request"),
    buttonText: "Create your free workspace"
  };

  var collectDriftFormData = function collectDriftFormData(formData) {
    var unTypedWindow = window;

    if (unTypedWindow.drift) {
      unTypedWindow.drift.api.collectFormData(_objectSpread(_objectSpread({}, formData), {}, {
        firstName: formData.name.split(" ")[0],
        lastName: formData.name.split(" ").slice(1).join(" ")
      }), {
        campaignId: driftCampaignId
      });
    }
  };

  (0,react.useEffect)(function () {
    if (methods.getValues("phone")) {
      methods.trigger("phone");
    }
  }, [intPhoneErrorCode]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: FORM_ID,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, _objectSpread(_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: isLeadEnrichmentFormEnabled ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message"
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "error",
          "data-hook": "demo-form-error-message"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: function onSubmit(data) {
          setSubmittedEmail(data.email);
          (0,helpers/* createDemoLead */.Ii)(data);

          if (driftCampaignId) {
            collectDriftFormData(data);
          }

          if (isSmallResolution && showProgressiveFields) {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, MOBILE_OFFSET, false);
          } else {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, DESKTOP_OFFSET, false);
          }
        },
        onFailure: helpers/* trackValidationErrorDemoForm */.nR,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier,
        customTrackingType: customTrackingType
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, {
          onBlur: helpers/* trackValidationErrorDemoForm */.nR
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* FullNameField */.AM, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* PhoneNumberField */.g8, {
            countryCode: countryCode,
            onValidate: setIntPhoneErrorCode,
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyNameField */.wA, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), isPersonalEmail && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyWebsiteField */.Zf, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          })]
        }), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: buttonText
          })
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisclaimerWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
            data: customDisclaimer,
            appearance: successMessageAppearance
          })
        })]
      }))
    }), isLeadEnrichmentFormEnabled && methods.formState.isSubmitSuccessful && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressiveProfileForm/* ProgressiveProfileForm */.u, {
      before: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitMessage/* FormSubmitMessage */.f, {
        status: "success",
        form: "demo"
      }),
      email: submittedEmail,
      successMessage: successMessage
    })]
  });
};
/* harmony default export */ var DemoForm_DemoForm = ((/* unused pure expression or super */ null && (DemoForm)));
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/index.ts


/***/ }),

/***/ 6612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ ProgressiveProfileForm; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 23 modules
var FormFields = __webpack_require__(20444);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/FormFields/JobTitle.tsx
var JobTitle = __webpack_require__(96321);
// EXTERNAL MODULE: ../../libs/templates/FormFields/Timeline.tsx
var Timeline = __webpack_require__(12307);
// EXTERNAL MODULE: ../../libs/templates/FormFields/MonthlyTraffic.tsx
var MonthlyTraffic = __webpack_require__(75886);
// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanySize.tsx
var CompanySize = __webpack_require__(20417);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/HiddenEmail.tsx


var _excluded = ["type", "name", "id", "className", "dataHook", "value"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




/**
 * Email hidden input for demo forms
 */

var HiddenEmailField = function HiddenEmailField(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "hidden" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "email" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "email" : _ref$id,
      className = _ref.className,
      dataHook = _ref.dataHook,
      value = _ref.value,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread(_objectSpread({
    "data-testid": "email",
    className: className,
    id: id,
    type: type,
    "data-hook": dataHook,
    value: value
  }, register(name, {})), rest));
};
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/contexts/demo.tsx
var demo = __webpack_require__(805);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja1"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx



var ProgressiveProfileForm_excluded = ["appearance", "className", "before", "after", "overrideConsent", "customFormIdentifier", "successMessageAppearance", "email", "successMessage"];


function ProgressiveProfileForm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ProgressiveProfileForm_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ProgressiveProfileForm_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProgressiveProfileForm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
























var BUTTON_TEXT = "Let's get started";
/* eslint-disable camelcase */

var schema = lib/* object */.Ry({
  jobTitle: lib/* string */.Z_({
    required_error: JobTitle/* jobTitleMessages.required */.cY.required
  }).regex(regexes_form/* default */.Z, {
    message: JobTitle/* jobTitleMessages.invalid */.cY.invalid
  }),
  companySize: lib/* string */.Z_({
    required_error: CompanySize/* companySizeMessages.required */.CF.required
  }),
  monthlyTraffic: lib/* string */.Z_({
    required_error: MonthlyTraffic/* monthlyTrafficMessages.required */.dn.required
  }),
  timeline: lib/* string */.Z_({
    required_error: Timeline/* timelineMessages.required */.Cb.required
  }),
  email: lib/* string */.Z_().optional()
});
/* eslint-enable camelcase */
// Set up demo form props since we define some of these props here in the template

var ProgressiveProfileForm = function ProgressiveProfileForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      successMessageAppearance = _ref.successMessageAppearance,
      email = _ref.email,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ProgressiveProfileForm_excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var scrollTo = (0,useScrollToAnchor/* default */.Z)("progressive-profile-form", -200);

  var _useContext = (0,react.useContext)(demo/* DemoContext */.d),
      setCompletedFormData = _useContext.setCompletedFormData; // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality


  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  });
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo-request"),
    buttonText: "Create your free workspace"
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: "progressive-profile-form",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, ProgressiveProfileForm_objectSpread(ProgressiveProfileForm_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message",
          onButtonClick: function onButtonClick() {
            (0,helpers/* trackButtonClick */.kO)({
              buttonText: successMessage.buttonText,
              buttonId: "Workspace signup",
              targetUrl: successMessage.buttonUrl
            });
          }
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          status: "error"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: /*#__PURE__*/function () {
          var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    setCompletedFormData(data);
                    _context.next = 3;
                    return (0,helpers/* trackProgressiveProfileForm */.NX)(data);

                  case 3:
                    scrollTo();

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        onFailure: helpers/* trackValidationErrorProgressiveProfileForm */.An,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobTitle/* JobTitleField */.kL, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySize/* CompanySizeSelectField */.BQ, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MonthlyTraffic/* MonthlyTrafficSelectField */.VW, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Timeline/* TimelineSelectField */.fz, {}), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), email && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HiddenEmailField, {
          value: email
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: BUTTON_TEXT
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
          appearance: successMessageAppearance
        })]
      }))
    })
  });
};
/* harmony default export */ var ProgressiveProfileForm_ProgressiveProfileForm = ((/* unused pure expression or super */ null && (ProgressiveProfileForm)));

/***/ }),

/***/ 6087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ LogoCarousel_LogoCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/recipes/LogoCarousel/index.ts + 8 modules
var LogoCarousel = __webpack_require__(74595);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/LogoCarousel.tsx


var _excluded = ["heading", "logos", "appearance", "headingVariant"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var getDefaultLogos = function getDefaultLogos(logosMap) {
  return [logosMap.DIGITAL_OCEAN, logosMap.IBM, logosMap.DOMINOS, logosMap.ANHEUSER_BUSCH, logosMap.VMWARE, logosMap.LEVIS, logosMap.LOG_ME_IN, logosMap.CLEAR_SCORE, logosMap.VACASA, logosMap.STAPLES, logosMap.INTUIT, logosMap.THE_SKIMM, logosMap.DRIFT, logosMap.ALLERGAN, logosMap.GLOSSIER, logosMap.AB_IN_BEV];
};

var LogoCarouselTemplate = function LogoCarouselTemplate(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Join the 25,000+ companies using the Segment platform" : _ref$heading,
      externalLogos = _ref.logos,
      externalAppearance = _ref.appearance,
      headingVariant = _ref.headingVariant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var finalLogos = externalLogos !== null && externalLogos !== void 0 ? externalLogos : getDefaultLogos(appearance === "twilioLight" ? data/* carouselLogos */.j : data/* carouselLogosMono */.G);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoCarousel/* default */.ZP, _objectSpread(_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* Heading */.X6, {
      variant: headingVariant,
      children: heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* LogoTrack */.xS, {
      icons: finalLogos
    })]
  }));
};

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarouselTemplate);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/index.ts


/***/ }),

/***/ 51895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var lastName = /^(?![\s\S]*\s[;,?=+\-@])[^;,?=+\-@\s][\s\S]+$/g;
/* harmony default export */ __webpack_exports__["Z"] = (lastName);

/***/ }),

/***/ 6133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketing",
      function () {
        return __webpack_require__(8936);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useInterval = function (callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () { });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInterval);


/***/ }),

/***/ 62806:
/***/ (function(module) {

module.exports = "/_next/static/images/OgMarketing-abdc1daee07d7e2c30a1ee1cb47187e5.jpeg";

/***/ }),

/***/ 5083:
/***/ (function(module) {

module.exports = "/_next/static/images/DeliverUnifiedCustomerExperiences@2x-cac6244e237393b7671f5e24c0963c1e.png";

/***/ }),

/***/ 77481:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-cb1694d069d5a43f5bf91f366f16466d.png";

/***/ }),

/***/ 85891:
/***/ (function(module) {

module.exports = "/_next/static/images/DeliverUnifiedCustomerExperiences-462ebe115564e21a4f9d28d2a36a1897.webp";

/***/ }),

/***/ 80405:
/***/ (function(module) {

module.exports = "/_next/static/images/DeliverUnifiedCustomerExperiences@2x-5d35e04d6088847aece2570acbec5edc.webp";

/***/ }),

/***/ 37883:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-13dbf1635aab4b2ffe7220a2cbb424d2.webp";

/***/ }),

/***/ 39764:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-b51fb8825ff2085bdee42956286696d6.webp";

/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,1382,4136,2073,8392,5735,2429,7303,948,8187,3996,7947,7960,6012,7079,1385,3379,9550,5062,814,9774,2888,179], function() { return __webpack_exec__(6133); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);